import {takeEvery} from 'redux-saga/effects'
import {
  ADD_CLASS,
  ADD_CLASS_RESOURCE,
  ASSIGN_TEACHERS,
  CLASS_STUDENT_SUBJECT_REPORT,
  DELETE_CLASS,
  DELETE_CLASS_RESOURCE,
  DELETE_MANY_CLASSES,
  GENERATE_CLASS_STREGNTH_LIST,
  GET_CLASS,
  GET_CLASSES,
  GET_CLASS_RESOURCES,
  GET_CLASS_STUDENTS,
  GET_CLASS_SUBJECTS,
  GET_PREVIOUS_CLASSES,
  GET_STUDENTS_FROM_MULTIPLE_CLASSES,
  GET_SUBJECTS_CLASSES,
  INACTIVATE_CLASS,
  PROMOTE_STUDENTS,
  UPDATE_CLASS,
  UPDATE_CLASS_SEQUENCE,
} from 'setup/redux/Actions/Class/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_CLASSES, fetchData)
  yield takeEvery(GET_CLASS, fetchData)
  yield takeEvery(DELETE_CLASS, fetchData)
  yield takeEvery(INACTIVATE_CLASS, fetchData)
  yield takeEvery(ADD_CLASS, fetchData)
  yield takeEvery(DELETE_MANY_CLASSES, fetchData)
  yield takeEvery(UPDATE_CLASS, fetchData)
  yield takeEvery(ADD_CLASS_RESOURCE, fetchData)
  yield takeEvery(GET_CLASS_RESOURCES, fetchData)
  yield takeEvery(GET_CLASS_STUDENTS, fetchData)
  yield takeEvery(GET_CLASS_SUBJECTS, fetchData)
  yield takeEvery(DELETE_CLASS_RESOURCE, fetchData)
  yield takeEvery(UPDATE_CLASS_SEQUENCE, fetchData)
  yield takeEvery(GENERATE_CLASS_STREGNTH_LIST, fetchData)
  yield takeEvery(PROMOTE_STUDENTS, fetchData)
  yield takeEvery(GET_PREVIOUS_CLASSES, fetchData)
  yield takeEvery(ASSIGN_TEACHERS, fetchData)
  yield takeEvery(CLASS_STUDENT_SUBJECT_REPORT, fetchData)
  yield takeEvery(GET_SUBJECTS_CLASSES, fetchData)
  yield takeEvery(GET_STUDENTS_FROM_MULTIPLE_CLASSES, fetchData)
}

export default dataSaga
